import React from 'react';
import { Button } from '@dapp/multi-lib/sdaoui/Button';
import Link from 'next/link';

interface LaunchpadButtonProps {
  label: string;
  href: string;
  className?: string;
}

export const LaunchpadButton: React.FC<LaunchpadButtonProps> = ({
  label,
  href,
  className,
}) => {
  return (
    <Button href={href} className={className} component={Link}>
      {label}
    </Button>
  );
};
